function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon Design - Merged"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.42 11.374a5 5 0 10-4.84 0A8.014 8.014 0 004 19v2.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V19a8.014 8.014 0 00-5.58-7.626zM8 7a4 4 0 114 4 4.004 4.004 0 01-4-4zm11 14H5v-2a7 7 0 0114 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})));